import React from 'react';
import { StyledOcticon } from '@primer/react';

import { BugIcon } from '@primer/octicons-react';

import BlankSlate from '../common/BlankSlate/BlankSlate';
import LinkLabel from '../common/Labels/LinkLabel';

const ErrorGraphic = () => (
  <StyledOcticon
    className="text-brand"
    icon={BugIcon}
    size={64}
  />
)

const ErrorCTA = () => (
  <div>
    If this error persists, write to <LinkLabel to="mailto:support@wallaroo.ai">support@wallaroo.ai</LinkLabel> and we’ll be in touch to help you shortly.
  </div>
)

export const ErrorSlate = ({
  errorText,
  subText = 'Please refresh the page.',
  CTAInfo = ErrorCTA,
  Graphic = ErrorGraphic,
}) => (
  <BlankSlate
    className="p-4"
    mainText={errorText}
    subText={subText}
    CTAInfo={CTAInfo}
    Graphic={Graphic}
  />
)

export default ErrorSlate;
